module.exports = __webpack_public_path__ + "img/comment-active.7b1670be.svg";